import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import CDList from "../components/creditCards/list/cdList";
import CDEditProfile from "../components/creditCards/edit/CDEdit";
import CDReviewProfile from "../components/creditCards/reviewProfile/CDReviewProfile";
import CDUpload from "../components/creditCards/upload/CDUpload";
import CDCard from "../components/creditCards/card/CDCard";
import CDReviewRequest from "../components/creditCards/reviewRequest/CDReviewRequest";
import CDFinal from "../components/creditCards/final/CDFinal";

export const creditCardRoutes = [
	<Route
		key="cc-list"
		path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.List}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDList} />}
	/>,
	<Route
		key="cc-edit"
		path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Edit}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDEditProfile} />}
	/>,
	<Route
		key="cc-profile"
		path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Profile}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDReviewProfile} />}
	/>,
	<Route
		key="cc-document"
		path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Document}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDUpload} />}
	/>,
	<Route
		key="cc-card"
		path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Card}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDCard} />}
	/>,
	<Route
		key="cc-review"
		path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Review}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDReviewRequest} />}
	/>,
	<Route
		key="cc-final"
		path={_adr.Root + _adr.CreditCard.Index + _adr.CreditCard.Final}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CDFinal} />}
	/>,
];
